import { QCApi } from '../../../../api/Operations/Engineering/QC'
import QC from '../../../../components/Operations/Engineering/QC/QC'
import React from 'react'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useTitle from '../../../../elements/Hooks/useTitle'
import useListCompanyFilter from '../../../../elements/Hooks/useListCompanyFilter'

function QCCont() {
  const { list: cached, fetching, fetch } = useFetchList(() => QCApi.list())

  const { list, company, onChangeCompany } = useListCompanyFilter(cached, fetching)
  useTitle('QC')

  return (
    <QC
      {...{
        list,
        fetching,
        fetch,
        company,
        onChangeCompany,
      }}
    />
  )
}

export default QCCont
